import { bindActionCreators } from 'redux';
import { getAirports } from './airports.actions';
import { getContacts } from './contacts.actions';
import { getEvents } from './events.actions';
import { getRampServices } from './ramp-services.actions';
import store from './index';

type StopPolling = () => void;

let timerId: ReturnType<typeof setTimeout> | null = null;
let stopped = false;

const poll = async (actions: ReturnType<typeof createActions>) => {
  // TODO add airports polling after
  // actions.getAirports();
  await Promise.allSettled([actions.getContacts(), actions.getEvents()]);
};

const scheduleNext = (
  actions: ReturnType<typeof createActions>,
  timeout: number
) => {
  timerId = setTimeout(async () => {
    if (stopped) return;
    await poll(actions);
    if (stopped) return;
    scheduleNext(actions, timeout);
  }, timeout);
};

const createActions = () =>
  bindActionCreators(
    {
      getAirports,
      getContacts,
      getEvents,
      getRampServices,
    },
    store.dispatch
  );

const polling = (timeout: number = 30000): StopPolling => {
  const actions = createActions();
  stopped = false;

  // Initial fetch
  actions.getRampServices();

  scheduleNext(actions, timeout);

  return () => {
    stopped = true;
    if (timerId != null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };
};

export default polling;
